import React, { useEffect, useRef, useState } from 'react';
import Card from './Card';
import './FlyingCard.css';

export default function FlyingCard({ card, startPos, targetPos, faceUp = true, variant = '', onComplete }) {
  const [landed, setLanded] = useState(false);
  const completedRef = useRef(false);

  useEffect(() => {
    if (!startPos || !targetPos) return undefined;
    completedRef.current = false;
    setLanded(false);
    const id = requestAnimationFrame(() => setLanded(true));
    return () => cancelAnimationFrame(id);
  }, [startPos, targetPos, card?.id]);

  const handleTransitionEnd = (e) => {
    if (e.target !== e.currentTarget) return;
    if (completedRef.current) return;
    if (e.propertyName === 'transform' || e.propertyName === 'left' || e.propertyName === 'top') {
      completedRef.current = true;
      onComplete?.(card);
    }
  };

  if (!card || !startPos || !targetPos) return null;

  const style = {
    '--start-x': `${startPos.x}px`,
    '--start-y': `${startPos.y}px`,
    '--target-x': `${targetPos.x}px`,
    '--target-y': `${targetPos.y}px`,
  };

  return (
    <div
      className={`flying-card ${landed ? 'flying-card--landed' : ''} ${variant ? `flying-card--${variant}` : ''}`}
      style={style}
      onTransitionEnd={handleTransitionEnd}
    >
      <Card card={card} faceUp={faceUp} />
    </div>
  );
}
